import styled from 'styled-components';

export const TabbedDropdownContainer = styled.div`
  min-width: 20em;
  width: 100%;
  border-radius: 5px;
  line-height: 26px;
  position: relative;
`;

export const DropdownToggle = styled.button`
  background: #ffffff;
  border: 1px solid #ccc;
  padding-left: 0.75rem;
  padding-right: 1.5rem;
  cursor: pointer;
  border-radius: 5px;
  width: 22em;
  height: 42px;
  text-align: left;
  position: relative;
  &:after {
    content: '▼';
    font-size: 0.52rem;
    top: 8px;
    right: 10px;
    position: absolute;
  }
`;

export const DropdownMenu = styled.div`
  position: absolute;
  top: 100%;
  left: 0;
  width: 22em;
  background-color: #fff;
  border: 1px solid #ccc;
  border-top: none;
  border-radius: 0 0 5px 5px;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
  z-index: 10;
  min-width: 22em;
  height: 22em;
  overflow-y: auto;
`;

export const TabsHeader = styled.div`
  display: flex;
  justify-content: space-between;
  border-bottom: 1px solid #ccc;
`;

export const TabButton = styled.button<{ active?: boolean }>`
  flex: 1;
  padding: 10px;
  background-color: ${({ active }) => (active ? '#fff' : '#eee')};
  border: none;
  cursor: pointer;
  border-bottom: 2px solid
    ${({ active }) => (active ? '#007bff' : 'transparent')};
  font-weight: ${({ active }) => (active ? 'bold' : 'normal')};
`;

export const TabContent = styled.div``;

export const ItemList = styled.ul`
  list-style: none;
  padding: 0;
  margin-top: 8px;
`;

export const Item = styled.li<{ selected?: boolean }>`
  margin: 0 10px;
  padding: 8px 0;
  cursor: pointer;
  background-color: ${({ selected }) => (selected ? '#e6f7ff' : 'transparent')};
  font-weight: ${({ selected }) => (selected ? 'bold' : 'normal')};
  display: flex;
  &:hover {
    background-color: #f0f0f0;
  }
`;

export const SearchInput = styled.input`
  width: 95%;
  padding: 8px 10px;
  margin-left: 10px;
  border: 1px solid #ccc;
  border-radius: 4px;
`;

export const NoResults = styled.li`
  padding: 8px 10px;
  color: #888;
  text-align: center;
`;

export const ButtonListItem = styled.button`
  margin: 0 25px 0 0px;
  border: none;
  background: none;

  height: 100%;
  text-align: left;
`;

export const SelectAllOption = styled.li`
  margin: 0 10px;
  padding: 8px 0;
  cursor: pointer;
  font-weight: bold;
  border-bottom: 1px solid #eee;

  &:hover {
    background-color: #f0f0f0;
  }
`;
